"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdown = void 0;
const global_1 = require("../global");
/**
 * ドロップダウン
 */
const dropdown = () => {
    console.log(document.getElementsByClassName("js-dropdown"));
    [...document.getElementsByClassName("js-dropdown")].forEach((element) => {
        const button = element.querySelector(".js-dropdown__button");
        const menu = element.querySelector(".js-dropdown__menu");
        button === null || button === void 0 ? void 0 : button.addEventListener("click", (e) => {
            e.preventDefault();
            const openMenu = () => {
                button === null || button === void 0 ? void 0 : button.classList.add("is-opened");
                menu === null || menu === void 0 ? void 0 : menu.classList.add("is-opened");
            };
            const closeMenu = () => {
                button === null || button === void 0 ? void 0 : button.classList.remove("is-opened");
                menu === null || menu === void 0 ? void 0 : menu.classList.remove("is-opened");
            };
            const onChangeMedia = () => {
                if (global_1.mediaQuery.matches)
                    closeMenu();
            };
            if (button.classList.contains("is-opened")) {
                closeMenu();
            }
            else {
                openMenu();
            }
            global_1.mediaQuery.addEventListener("change", onChangeMedia);
        });
    });
};
exports.dropdown = dropdown;
